import { countries } from "country-list-json";

import { SYSTEM_UNITS } from "constants/constantStrings";

export const SYSTEM_FIELDS = {
  SystemID: "SysId",
  SystemName: "SystemName",
  SystemUnits: "Units",
  SystemLocation: "Location",
  Size: "Size",
  DesignFlow: "DesignFlow",
  PreTreatment: "PreTreatment",
  PostTreatment: "PostTreatment",
  Max: "Max",
  Enabled: "Enabled",
  Address: "Address",
  CIT3Average: "CIT3_Average_threshold"
};

const systemKeys = Object.keys(SYSTEM_UNITS);

export const DEFAULT_SYSTEM_DATA = {
  [SYSTEM_FIELDS.SystemID]: "",
  [SYSTEM_FIELDS.SystemName]: "",
  [SYSTEM_FIELDS.SystemLocation]: undefined,
  [SYSTEM_FIELDS.Size]: undefined,
  [SYSTEM_FIELDS.DesignFlow]: undefined,
  [SYSTEM_FIELDS.Address]: undefined,
  [SYSTEM_FIELDS.Max]: false,
  [SYSTEM_FIELDS.Enabled]: false,
  [SYSTEM_FIELDS.PreTreatment]: false,
  [SYSTEM_FIELDS.PostTreatment]: false,
  [SYSTEM_FIELDS.SystemUnits]: systemKeys[0]
};

export const COUNTRIES_WITH_CODE = {};
countries.forEach(country => (COUNTRIES_WITH_CODE[country.code] = country.name));
